import { Component, OnInit, ViewChild, Output, EventEmitter, Input, ElementRef, Injector, ApplicationRef, ComponentFactoryResolver } from '@angular/core';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { SwMassageConfirmComponent } from 'src/app/librarys/components/basic-components/sw-massage-confirm/sw-massage-confirm.component';
import { ocrTextConfigBoxComponent } from '../ocr-text-config-box/ocr-text-config-box.component';
import { KmsService } from '../../../kms.service';
declare var $;
@Component({
  selector: 'ocr-text-config-compare-view',
  templateUrl: './ocr-text-config-compare-view.component.html',
  styleUrls: ['./ocr-text-config-compare-view.component.css'],
})
export class OcrTextConfigCompareViewComponent implements OnInit {
  @ViewChild('modal') modal: SwModalframeComponent;//弹出层组件
  @ViewChild("tirm2") tirm2: SwMassageConfirmComponent;//确认删除组件
  @ViewChild("tirm") tirm: SwMassageConfirmComponent; //选择确认框
  @Output() voted = new EventEmitter<void>(); //添加事件
  //图片原图信息：宽度，高度 ==>用于计算解析后的高度，和坐标比例系数
  imgWidth: number = null;
  imgHeight: number = null;
  //文字图片解析后的高度  ==> 宽度 400px是固定的，高度根据原图的宽高比例确定 ==>wordBoxHeight/740 == imgHeight/imgWidth ==>wordBoxHeight/imgHeight == 740/imgWidth
  wordBoxWidth: number = 1200 // 以电脑显示器 1920*1280 标准计算的最佳宽度 ===》所以值 1120固定
  wordBoxHeight: number = null;
  //坐标等比缩小或扩大的系数
  scale: number = 1
  //ocr识别后的字体坐标
  ocrWordList: any = [] //数据格式 [[[[376,183],[428,183],[431,815],[380,185]],['忽忆故园好凤景线时道',"0.6754049"]],[[[376,183],[428,183],[431,815],[380,185]],['忽忆故园好凤景线时道',"0.6754049"]]]
  //初始化ocr识别字体的坐标
  ocrWordListInit: any = []
  //ocr获取的整体对象
  ocrObj: any = {}
  //是否要等比缩放
  isScale: boolean = true
  @Input() param: any;
  @Output() callback = new EventEmitter(); //抛出事件
  base64String: any
  headerLogo: any = '对比查看'
  imageId: any
  imageName: any
  bigImgUrl: any
  allBoxWidth: any = 0
  ids: any
  //ocr识别后的字体坐标
  initOcrStringDatas:string = '';
  //正文+注释数据
  ocrTextList: any = []; 
  //页眉数据
  ocrHeaderList: any = [];
  //页脚数据
  ocrFooterList: any = [];
  //中缝数据
  middleSeamList: any = [];
  // 新增的字
  addWords:any = [];
  //当前页提取文字的类型 { type:'text', show:true} type:文字类型-正文、注释、页眉、页脚、中缝；show: 是否显示
  types:any = [];
  typeOptions:any = [
      {id:'text',text:'正文'},
      {id:'note',text:'注释'},
      {id:'header',text:'页眉'},
      {id:'footer',text:'页脚'},
      {id:'middleSeam',text:'中缝'}
  ];
  //版面分析数据
  layoutJson:any = [];
  //素材id
  materialId:string = '';
  detailId:string = '';
  ocrRes:string = '';
  state = false;
  constructor(
    private kmsService: KmsService,
    private box: SwMassageBoxService,//消息弹出服务
    private message: SwMassageBoxService,
    private injector: Injector,
    private applicationRef: ApplicationRef,
    private componentFactoryResolver: ComponentFactoryResolver,
  ) { }

  ngOnInit() {
    this.ids = "octtextcompare" + Math.random().toString().split(".")[1];
    const ocrObj = this.param["viewData"]
    this.bigImgUrl = this.param["bigImgUrl"]
    this.detailId = ocrObj['detailId']
    this.materialId = ocrObj['materialId']
    this.ocrRes = ocrObj['ocrRes']
    this.loadPositonMode(ocrObj);
  }

  loadPositonMode(element) {
    if (!element.ocrJson) {
      return;
    }
    const ocrDatas = JSON.parse(element.ocrJson);
    this.initOcrStringDatas = element.ocrJson;
    this.layoutJson = ocrDatas.layout_res;
    // 获取识别图片的原始宽高信息
    this.imgWidth = ocrDatas.imginfo.width;
    this.imgHeight = ocrDatas.imginfo.height;
    if (this.wordBoxWidth / this.imgWidth < 1) {
        this.scale = parseFloat((this.wordBoxWidth / this.imgWidth).toFixed(2));
    } else {
        this.scale = 1
    }
    //获取ocr识别的文字坐标信息数组
    this.fetchOcrData(ocrDatas.ocr_res)
  }

  fetchOcrData(ocrJson) {
    this.types = [];
    this.addWords = [];
    this.ocrTextList = [];
    this.ocrHeaderList = [];
    this.ocrFooterList = [];
    this.middleSeamList = [];
    const ocrParams = this.getDataByType(ocrJson);
    // 将字排列时距离顶部30
    let offset = 0;
    if (ocrParams.minTop > 30) {
      offset = ocrParams.minTop - 30;
    }
    // 判断是否有正文
    if (ocrParams.hasText) {
      this.types.push({ type: 'text', name:'正文', selected: true });
      this.ocrTextList.forEach(el => {
        if(el.layout){
          el.layout.forEach(el1 => {
            el1.params.top = el1.params.top - offset;
          });
        }
        el.words.forEach(element => {
          element.params.top = element.params.top - offset;
        });
      });
    }
    // 判断是否有注释
    if (ocrParams.hasNote) {
      this.types.push({ type: 'note',name:'注释', selected: true })
    }
    // 判断是否有页眉
    if (ocrJson.header.length > 0) {
      this.types.push({ type: 'header',name:'页眉', selected: true });
      this.ocrHeaderList.forEach(el => {
        el.params.top = el.params.top - offset;
        el.words.forEach(element => {
          element.params.top = element.params.top - offset;
        });
      });
    }
    // 判断是否有页脚
    if (ocrJson.footer.length > 0) {
      this.types.push({ type: 'footer',name:'页脚', selected: true });
      this.ocrFooterList.forEach(el => {
        el.params.top = el.params.top - offset;
        el.words.forEach(element => {
          element.params.top = element.params.top - offset;
        });
      });
    }
    // 判断是否有中缝
    if (ocrJson.middleSeam.length > 0) {
      this.types.push({ type: 'middleSeam',name:'中缝', selected: true });
      this.middleSeamList.forEach(el => {
        el.params.top = el.params.top - offset;
        el.words.forEach(element => {
          element.params.top = element.params.top - offset;
        });
      });
    }
    this.wordBoxHeight = ocrParams.maxTop - offset + 50;
  }

  // 分别处理正文、注释、页眉、页脚
  getDataByType(ocrJson) {
    let hasText = false, hasNote = false;
    let minTop = 99999, maxTop = 0;
    const keys = Object.keys(ocrJson);
    const keys1 = [];
    keys.forEach(e => {
      if(e == 'content'){
        keys1.unshift(e);
      }else{
        keys1.push(e);
      }
    })
    const arr = JSON.parse(JSON.stringify(ocrJson['middleSeam']));
    arr.forEach(e => {
      e.words.forEach(m => {
        m.word = '';
      });
    });
    arr.forEach(e => {
      let on = true;
      ocrJson['content'].forEach((m,j) => {
        if(m.points.left<=e.points.left && on){
          on = false;
          ocrJson['content'].splice(j,0,e);
        }
      });
    });
    // ocrJson['content'] = ocrJson['content'].concat(arr);
    keys1.forEach(key => {
      if (key != 'others' && ocrJson[key].length > 0) {
        let textData = ocrJson[key];
        // 正文下包含了正文及注释两种类型的文字,对应的图片会有多个需额外处理
        if(key == 'content'){
          // 遍历版面分析结果数据
          this.layoutJson.forEach((l,m) => {
            // 提取类型为正文和注释的
            if(l.type == 'text' || l.type == 'note' || l.type == 'middleSeam'){
              // 获取该条版面分析结果对应矩形框x轴上的中心点
              const left = l.bbox[0];
              const right = l.bbox[2];
              const centerX = left + (right - left)/2;
              for(let i=0;i<textData.length;i++){
                const el = textData[i].points;
                // 中心点落在某一列内，则该条版面分析结果对应的图片属于当前列
                if(el.left <= centerX && el.right >= centerX){
                  let imgsrcurl = this.bigImgUrl + l.bbox[0] + "," + l.bbox[1] + "," + (l.bbox[2] - l.bbox[0]) + "," + (l.bbox[3] - l.bbox[1]) + "/full/0/default.jpg"
                  let word = {
                    points: {
                      left: l.bbox[0],
                      top: l.bbox[1],
                      right: l.bbox[2],
                      bottom: l.bbox[3]
                    }
                  }
                  const params = this.getShowParams(word, textData.length - i,'img');
                  const liImg = {
                    type: l.type,
                    imgLieUrl: imgsrcurl,
                    params: params
                  };
                  if(textData[i].layout){
                    textData[i].layout.push(liImg);
                  }else{
                    textData[i].layout = [liImg];
                  }
                  if(l.type == 'middleSeam'){
                    ocrJson['middleSeam'][0].liCount = textData.length - i;
                    // ocrJson['middleSeam'].forEach(e => {
                    //   const p = e.points;
                    //   if(l.right>l.left){
                        
                    //   }
                    // });
                  }
                  break;
                }
              }    
            }  
          });
        }
        // 遍历每一列
        textData.forEach((colomn, index1) => {
          let liCount = textData.length - index1;
          // 页眉、页脚、中缝的对应图片直接通过每一列的坐标、宽高来获取
          if(key != 'content'){
            // 以正文为标准分别获取页眉、页脚、中缝的文字应该属于哪一列
            if(ocrJson['content'].length > 0){
              liCount = this.getLiCount(colomn,ocrJson['content']);
            }
            if(key == 'middleSeam' && colomn.liCount){
              liCount = colomn.liCount;
            }
            let imgsrcurl = this.bigImgUrl + colomn.points.left + "," + colomn.points.top + "," + colomn.width + "," + colomn.height + "/full/0/default.jpg"
            colomn['imgLieUrl'] = imgsrcurl;
          }
          const params = this.getShowParams(colomn, liCount,'img');
          colomn['params'] = params;
          const num = params.width<80 ? 80-params.width : 0;
          let wordTypes = [];
          // 遍历每一列下的每个字
          colomn.words.forEach((word, index2) => {
            if (word.type == 'text') {
              hasText = true;
            }
            if (word.type == 'note') {
              hasNote = true;
            }
            if(!wordTypes.find(el => el == word.type)){
              wordTypes.push(word.type);
            }
            // 根据confidence设置文字样式
            const c = word.confidence;
            if(!c || c<=0.5){
                word['class']='red';
            }else if(c<=0.7){
                word['class']='yellow';
            }else{
                word['class']='';
            }
            // 获取页面展示所需的参数
            const params = this.getShowParams(word, liCount,'zi',num);
            word.params = params;
            // 计算top的最大值及最小值
            const top = params.top;
            if(top>maxTop){
                maxTop = top;
            }
            if(top<minTop){
                minTop = top;
            }
          });
          colomn['wordTypes'] = wordTypes;
        });
        if (key == 'header') {
          this.ocrHeaderList = textData;
        }
        if (key == 'footer') {
          this.ocrFooterList = textData;
        }
        if (key == 'middleSeam') {
          this.middleSeamList = textData;
        }
        if (key == 'content') {
          this.ocrTextList = textData;
        }
      }
    });
    return {
      hasText: hasText,
      hasNote: hasNote,
      minTop: minTop,
      maxTop: maxTop,
    }
  }

  // 根据字的坐标获取页面展示时的实际坐标及宽高
  getShowParams(word,liCount,type,num1?) {
    let points = word.points;
    // 每一列都要预留80px的偏移量用于显示图片
    let num = type == 'zi' ? liCount*80+10-num1 : (liCount-1)*80+10;
    if(this.scale != 1){
      const scale1 = parseFloat((this.imgWidth / this.wordBoxWidth).toFixed(2));
      num = num*scale1;
    }
    let leftTop = [points.left+num, points.top]
    let rightTop = [points.right+num, points.top]
    let rightBottom = [points.right+num, points.bottom]
    let leftBottom = [points.left+num, points.bottom]
    //乘上比例系数
    let leftTopScalse;
    let rightTopScalse;
    let rightBottomScalse;
    let leftBottomScalse;
    if (this.isScale) {
      //乘上比例系数 scale
      leftTopScalse = [(leftTop[0] * this.scale).toFixed(2), (leftTop[1] * this.scale).toFixed(2)];
      rightTopScalse = [(rightTop[0] * this.scale).toFixed(2), (rightTop[1] * this.scale).toFixed(2)];
      rightBottomScalse = [(rightBottom[0] * this.scale).toFixed(2), (rightBottom[1] * this.scale).toFixed(2)];
      leftBottomScalse = [(leftBottom[0] * this.scale).toFixed(2), (leftBottom[1] * this.scale).toFixed(2)];
    } else {
      //暂不乘上比例系数
      leftTopScalse = leftTop;
      rightTopScalse = rightTop;
      rightBottomScalse = rightBottom;
      leftBottomScalse = leftBottom;
    };
    //数据结构处理
    let wid = Number.parseFloat(rightTopScalse[0]) - Number.parseFloat(leftTopScalse[0])
    let higt = Number.parseFloat(leftBottomScalse[1]) - Number.parseFloat(leftTopScalse[1])
    //字体的大小
    let fontSize = word.fontSize*(this.scale === 1 ?  0.7 : this.scale);
    return {
      left: Number.parseFloat(leftTopScalse[0]),
      top: Number.parseFloat(leftTopScalse[1]),
      right: Number.parseFloat(rightTopScalse[0]),
      width: wid,
      height: higt,
      fontSize: fontSize
    };
  }

  // 以正文为标准分别获取页眉、页脚、中缝的文字应该属于哪一列,使正文、注释、页眉、页脚、中缝的相对位置尽量与图片整体保持一致
  getLiCount(column,textData){
    const left = column.points.left;
    let liIndex = 0;
    let state = false;
    for(let i=0;i<textData.length;i++){
      const left1 = textData[i].points.left;
      if(left>left1){
        liIndex = i - 1;
        state = true;
        break;
      }
    }
    if(state){
      return textData.length - (liIndex>=0 ? liIndex : 0);
    }else{
      return 1;
    }
  }

  // 文字纠正区域
  dropdown: boolean = false
  /**
   *  @ignore
   *  展现关闭下拉
   */
  swSelectMultiComponentRef: any;

  // 打开文字纠正弹框
  open(event, list, eleId, index1, index2) {
    event.stopPropagation()
    if ($('ocrtextconfigboxcomponent')) {
        $('body').find('ocrtextconfigboxcomponent').remove();
    }
    let isNeedJudgeCol = false
    let type = 2
    let title = '文字纠正';
    if (!isNeedJudgeCol) {
        const com = document.createElement(ocrTextConfigBoxComponent.name);
        //创建动态组件
        const factory = this.componentFactoryResolver.resolveComponentFactory(ocrTextConfigBoxComponent);
        this.swSelectMultiComponentRef = factory.create(this.injector, [], com);
        this.applicationRef.attachView(this.swSelectMultiComponentRef.hostView);
        // 打开下拉框
        this.dropdown = true;
        // 向动态创建的组件传递参数
        this.swSelectMultiComponentRef.instance["ids"] = this.ids;
        // 向动态创建的组件传递参数
        this.swSelectMultiComponentRef.instance["title"] = title;
        // 向动态创建的组件传递参数
        this.swSelectMultiComponentRef.instance["elemId"] = eleId;
        // 向动态创建的组件传递参数
        this.swSelectMultiComponentRef.instance["selectedValue"] = list;

        this.swSelectMultiComponentRef.instance["type"] = type;

        this.swSelectMultiComponentRef.instance["index"] = index1;

        this.swSelectMultiComponentRef.instance["index2"] = index2;

        this.swSelectMultiComponentRef.instance["configHeight"] = '150px';
        // 向动态创建的组件传递回调函数
        this.swSelectMultiComponentRef.instance["closeSelect"].subscribe(data => {
            try {
                this.dropdown = false
                // 失去焦点
                // this.input.nativeElement.blur()
                // 移除元素
                document.body.removeChild(com);
                this.applicationRef.detachView(this.swSelectMultiComponentRef.hostView);
                // 销毁组件
                this.swSelectMultiComponentRef.destroy()
            } catch (e) { }

        });

        this.swSelectMultiComponentRef.instance["changeClick"].subscribe(data => {
            try {
                // 有参数就触发此事件 抛出选择的参数对象
                this.updateConfig(data)
            } catch (e) { }

        });
        // 将组件加到dom中去显示
        document.body.appendChild(com);
    }
  }

  //更新对应数组的参数值 ==>以后扩展框选功能时，要修改
  updateConfig(config) {
    // 编辑字
    if (config.type == 'edit') {
      if(config.textType == 'header'){
          this.ocrHeaderList[config.index].words[config.index2]['word'] =  config.value;
          this.ocrHeaderList[config.index].words[config.index2]['confidence'] =  1;
      }else if(config.textType == 'footer'){
          this.ocrFooterList[config.index].words[config.index2]['word'] =  config.value;
          this.ocrFooterList[config.index].words[config.index2]['confidence'] =  1;
      }else if(config.textType == 'middleSeam'){
          this.middleSeamList[config.index].words[config.index2]['word'] =  config.value;
          this.middleSeamList[config.index].words[config.index2]['confidence'] =  1;
      }else {
          this.ocrTextList[config.index].words[config.index2]['word'] =  config.value;
          this.ocrTextList[config.index].words[config.index2]['confidence'] =  1;
      }
    } 
    // 删除字
    else if (config.type == 'delete') {
        if(config.textType == 'header'){
            this.ocrHeaderList[config.index].words.splice(config.index2, 1);
        }else if(config.textType == 'footer'){
            this.ocrFooterList[config.index].words.splice(config.index2, 1);
        } if(config.textType == 'middleSeam'){
            this.middleSeamList[config.index].words.splice(config.index2, 1);
        }else {
            this.ocrTextList[config.index].words.splice(config.index2, 1);
        }
    }
    this.updateMaterialContent();
    this.close();
  }

  // 新增、修改、删除字后，进行保存操作
  updateMaterialContent(){
    let ocrJson = JSON.parse(this.initOcrStringDatas);
    ocrJson.ocr_res.header = this.ocrHeaderList;
    ocrJson.ocr_res.content = this.ocrTextList;
    ocrJson.ocr_res.footer = this.ocrFooterList;
    ocrJson.ocr_res.middleSeam = this.middleSeamList;
    ocrJson.ocr_res.addWords = this.addWords;
    ocrJson.layout_res = this.layoutJson;
    let jsonStr = JSON.stringify(ocrJson);
    // 新增、修改、删除字后,重新获取排好顺序的json对象
    this.kmsService.ocrSort({'orcjson': jsonStr}).subscribe(
        data => {
            if(data.code == '200'){
                const res = data.data;
                // 拼接参数
                let params:any = {
                  detailId: this.detailId,
                  materialId: this.materialId,
                  ocrRes: this.ocrRes
                };
                // 获取添加字之后的带坐标的文本字段值
                params.ocrJson = JSON.stringify(res);
                params.materialText = res.text.fullText;
                // 更新素材内容
                this.kmsService.updateMaterialDetail(params).subscribe(
                    result => {
                        if (result.code == '200') {
                            this.box.success('操作成功！');
                            this.loadPositonMode(params);
                            this.state = true;
                        } else {
                            this.box.waring('操作失败！');
                        }
                    }
                );
            }
        }
    )
  }

  /**
     * 关闭下拉框
     * @ignore
     */
  close() {
    // this.dropdown = false;
    this.swSelectMultiComponentRef.instance.close()
  }

  // 选择要显示的文字内容
  selectType(item){
    item.selected = !item.selected;
    if(item.name == '正文'){
      if(item.selected){
        $('.img-text').show();
        $('.exps.text').show();
      }else{
        $('.img-text').hide();
        $('.exps.text').hide();
      }
    }
    if(item.name == '注释'){
      if(item.selected){
        $('.img-note').show();
        $('.exps.note').show();
      }else{
        $('.img-note').hide();
        $('.exps.note').hide();
      }
    }
  }

  // 根据传入的类型判断是否显示
  check(typeArr){
    let isSelected = false;
    if(this.types.length>0){
      typeArr.forEach(element => {
        let item = this.types.find(el => el.type == element);
        if(item && item.selected){
          isSelected = item.selected;
        }
      });
    }
    return isSelected;
  }
}

